import AbstractLayerManager from './AbstractLayerManager';
import Request from '../../Request';

export default class WxObsLayerManager extends AbstractLayerManager {
	constructor(myKey, instance) {
		super(myKey, instance);
		this.name = "Observations";
		this.popupName = "Observation";
		this.options.hasPanRefresh = true;
		this.options.hasAutoRefresh = true;

		this.dataOptions = {'mVar': 'ticon'};
	}
	
	refreshLayer() {
		this.requestWxObs();
	}
	
	requestWxObs() {
		console.log('requestWxObs called');

		this.inst.setLoadingMonitor(this.id, true);

		if(this.tasks.fetchObs === undefined) this.tasks.fetchObs = new Request({
			url: 'https://api.weatherusa.net/v1/feed/obs',
			link: 'cancel',
			timeout: 30000,
			onSuccess: this.handleResp.bind(this),
			onError: this.handleError.bind(this)
		});

		this.tasks.fetchObs.get({
			bounds: this.inst.map.getBounds().toBBoxString(),
			zoom: this.inst.map.getZoom(),
			icon: true
		});
	}

	handleError(err) {
		console.error(err);
		this.inst.setLoadingMonitor(this.id, false);
	}
	
	handleResp(resp) {
		if(!this.layer) {
			console.error('Could not find layer for layer ID: ' + this.id);
			return false;
		}
		let wxObs = resp.body;
		this.layer.clearLayers();
		this.stations = {};
		
		for(const [id, data] of Object.entries(wxObs)) {

//			if((data.sky.length > 0 || data.cond.length > 0))
//			{
//				var size = [92, 64];
//				var anchor = [45, 31];
//			}
//			else
//			{
				var size = [64, 64];
				var anchor = [31, 31];
//			}
			var localIcon = null;
			var obs_var = (this.dataOptions.mVar || $('#wxObs_option').val()); // jq

			if(obs_var == 'ticon')
			{
				if(data.t_f === null || !data.icon) continue;
				// iconUrl: 'https://www.weatherusa.net/weathernet/icon_svg.php?t=' + data.t_f + '&cond=' + encodeURIComponent(data.cond) + '&sky=' + data.sky + '&ws=' + data.wspeed_mph + '&wd=' + data.wdir_compass,
				localIcon = new L.Icon({
					iconUrl: data.icon,
					iconSize: size,
					iconAnchor: anchor
				});
			}
			else if(obs_var == 't' || obs_var == 'td')
			{
				if(obs_var == 't')
				{
					var res = data.t_f;
				}
				else
				{
					var res = data.td_f;
				}
				if(res === null) continue;
				var txtEls = '<span class="r' + Math.floor(res / 10) + '">' + res + '°</span>';
				if(this.is_ie === true) txtEls += '<span class="ieshadow1 r' + Math.floor(res / 10) + '">' + res + '°</span><span class="ieshadow2 r' + Math.floor(res / 10) + '">' + res + '°</span>';
				localIcon = new L.DivIcon({
					iconSize: [46, 19],
					className: 'map_marker_t',
					html: txtEls
				});
			}
			else if(obs_var == 'chill')
			{
				if(data.chill === null) continue;
				localIcon = new L.DivIcon({
					iconSize: [46, 19],
					className: 'map_marker_t',
					html: '<span class="r' + Math.floor(data.chill / 10) + '">' + data.chill + '</span>'
				});
			}
			else if(obs_var == 'wgust')
			{
				if(data.wgust_mph === null) continue;
				localIcon = new L.DivIcon({
					iconSize: [36, 19],
					className: 'map_marker_wgust',
					html: '<span class="r' + Math.floor(data.wgust_mph / 10) + '">' + data.wgust_mph + '</span>'
				});
			}
			if(localIcon) {
				this.stations[id] = new L.Marker(new L.LatLng(data.lat, data.lon), {
					icon: localIcon,
					title: data.stname + ' (' + id + ')',
					zIndexOffset: 1119
				}).addTo(this.layer);

				var contentStr = 'Station Name: ' + data.stname + ' (' + id + ')<br />Network: ' + data.net + '<br />Temperature: ' + data.t_f + '°F<br />';
				if(data.feelslike !== null) contentStr += 'Feels like: ' + data.chill + '°F<br />';
				if(data.td_f !== null) contentStr += 'Dewpoint: ' + data.td_f + '°F<br />';
				if(data.wspeed_mph !== null)
				{
					contentStr += 'Winds: ';
					if(data.wdir_compass === null) data.wdir_compass = '';
					if(data.wspeed_mph > 0)
					{
						contentStr += data.wdir_compass + ' ' + data.wspeed_mph + ' MPH';
					}
					else
					{
						contentStr += 'Calm';
					}
					if(data.wgust_mph != null && data.wgust_mph > 0 && data.wspeed_mph > 0) contentStr += ' G ' + data.wgust_mph;
					contentStr += '<br />';
				}
				if(data.p_hpa !== null) contentStr += 'Pressure: ' + data.p_hpa + ' hPa (' + data.p_in + ' in.)<br />';
				contentStr += 'Last updated: ' + data.obstime;
				this.stations[id].details = contentStr;
				this.stations[id].on('click', this.handleClick, this);
			}
		}

		this.inst.setLoadingMonitor(this.id, false);
	}

	handleClick(e) {
		this.inst.forwardedClickHandler(this.id, e, e.target.details);
	}

	getLayerPopupContent(layer) {
		return layer.details;
	}
}